/**
 * Thin wrappers around browser globals for testability and a single seam for redirects/storage.
 */
export const navigation = {
  redirectTo: (url: string) => {
    window.location.href = url;
  },
  openInNewTab: (url: string) => {
    window.open(url, '_blank');
  },
};

export const storage = {
  /**
   * Clears localStorage (MSAL token cache + app state) on logout or 401.
   * sessionStorage is intentionally NOT cleared here — it is tab-scoped and
   * holds the post-login returnUrl that must survive a 401 → redirect → login cycle.
   */
  clearAll: () => {
    localStorage.clear();
  },
  getItem: (key: string) => localStorage.getItem(key),
  setItem: (key: string, value: string) => localStorage.setItem(key, value),
};
